var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { adoptedStyle, customElement, attribute } from '@mantou/gem/lib/decorators';
import { GemElement } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
const style = createCSSSheet(css `
  dy-space {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4em;
  }
  dy-space[size='small'] {
    gap: 0.2em;
  }
  dy-space[size='large'] {
    gap: 0.8em;
  }
`);
/**
 * @customElement dy-space
 * @attr size
 */
let DuoyunSpaceElement = class DuoyunSpaceElement extends GemElement {
    constructor() {
        super({ isLight: true });
    }
};
__decorate([
    attribute
], DuoyunSpaceElement.prototype, "size", void 0);
DuoyunSpaceElement = __decorate([
    customElement('dy-space'),
    adoptedStyle(style)
], DuoyunSpaceElement);
export { DuoyunSpaceElement };
//# sourceMappingURL=space.js.map